const YOUTUBE_ID_PATTERN = /(?:youtube\.com\/(?:embed\/|shorts\/|live\/|watch\?(?:[^#]*?&)?v=)|youtu\.be\/)([A-Za-z0-9_-]{11})/;

export const getYoutubeVideoId = raw => {
  if (raw == null) return null;

  const value = String(raw).trim();
  if (!value) return null;

  const match = value.match(YOUTUBE_ID_PATTERN);
  return match ? match[1] : null;
};

export const getVideoPosterSrc = raw => {
  const videoId = getYoutubeVideoId(raw);
  return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;
};

export const toVideoEmbedSrc = raw => {
  if (raw == null) return null;

  const value = String(raw).trim();
  if (!value || value.toLowerCase() === 'null' || value.toLowerCase() === 'undefined') {
    return null;
  }

  const youtubeId = getYoutubeVideoId(value);
  if (youtubeId) {
    return `https://www.youtube.com/embed/${youtubeId}`;
  }

  const iframeSrcMatch = value.match(/<iframe[^>]+src=["']([^"']+)["']/i);
  if (iframeSrcMatch) {
    return iframeSrcMatch[1];
  }

  if ((/^https?:\/\//i).test(value)) {
    return value;
  }

  return null;
};

export const isDirectVideoUrl = url => (/\.(mp4|webm|ogg)(\?|#|$)/i).test(url || '');
